import React, { Component, Fragment } from 'react';
import AuthService from './services/AuthService'
import PropTypes from 'prop-types';
import { API } from 'aws-amplify';
import { roomNames } from './Settings';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import BigCalendar from 'react-big-calendar';
import './css/react-big-calendar.css';
import moment from 'moment';
import 'moment/locale/ja';
import { withSnackbar } from 'notistack';
import $ from 'jquery';
import JapaneseHolidays from 'japanese-holidays';


let navigate = {
    PREVIOUS: 'PREV',
    NEXT: 'NEXT',
    TODAY: 'TODAY',
    DATE: 'DATE',
}

const getLastDay = (year, month) => {
    return new Date(year, month + 1, 0).getDate();
};

class CustomToolbar extends React.Component {
    render() {
        let { label } = this.props
        return(
            <div className="rbc-toolbar">
                <div className="rbc-btn-group">
                    <button type="button" onClick={this.navigate.bind(null, navigate.PREVIOUS)}>前月</button>
                </div>
                <div className="rbc-toolbar-label" onClick={this.navigate.bind(null, navigate.TODAY)}>{label}</div>
                <div className="rbc-btn-group">
                    <button type="button" onClick={this.navigate.bind(null, navigate.NEXT)}>翌月</button>
                </div>
            </div>
        )
    }
    navigate = action => {
        this.props.onNavigate(action)
    }
}

const styles = theme => ({
  root: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
});

let formats = {
   dateFormat: 'D',
   monthHeaderFormat : 'YYYY年 M月'

}

const initialState = {
  event: []
};

const localizer = BigCalendar.momentLocalizer(moment) // or globalizeLocalizer

class Calendar extends Component {

  constructor(props) {
    super(props);
    this.state = initialState;
    this.authApi = new AuthService();
  }

  componentWillMount(){
    $(".rbc-date-cell").html((index, element) => {
      let str = element
      let str1 = str.replace('<a href="#">', '<div>')
      let str2 = str1.replace('</a>', '</div>')
      return str2
    })

    let firstDay = moment().startOf('month').format("YYYY-MM-DD")

    //6段になる月のときに、eventが+more表示にならないように大きい方の高さに初期化する
    this.setState({
      calendarHeight: 1600,
      firstDay: firstDay
    }, () => {
      //未ログインでパス入力した際に、カレンダーにリダイレクトされるけど、パスが変わらない問題への対処
      this.props.setPath();

      //ニックネームの取得をリダイレクト先にもなっているcalendarだけでする
      this.props.setNickname();

      this.authApi.isLogin()
      .then(
        (login) => {
          if(!login){
            this.props.history.push('/login');
          }
        }
      );

      let today = new Date();
      let firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      let year = firstDay.getFullYear();
      let month = firstDay.getMonth();
      let monthDays = getLastDay(year, month);

      let event = []

      for (let i = 1 ; i < monthDays + 1; i++) {

        roomNames.map((room) => {
          event.push(
            {
              title: room,
              allDay: true,
              start: new Date(year, month, i),
              end: new Date(year, month, i),
              date: moment(new Date(year, month, i)).format('YYYY-MM-DD'),
              room: room,
              isReserved: false
            }
          )
          return true
        })

        event.push(
          {
            title: "満室表示",
            allDay: true,
            start: new Date(year, month, i),
            end: new Date(year, month, i),
            date: moment(new Date(year, month, i)).format('YYYY-MM-DD'),
            room: "",
            isReserved: false,
            isHolidayEvent: true,
            isHoliday: false
          }
        )

        this.setState({
          event: event
        })
      }

      let apiName = 'MyAPIGatewayAPI';
      let path = '/search-reservations-for-calendar'

      let body = {
        date: moment(firstDay).format("YYYY-MM-DD"),
      };

      let myInit = {
        body: body, // replace this with attributes you need
      }

      const { enqueueSnackbar } = this.props;

      API.post(apiName, path, myInit).then(response => {
        console.log(response);

        let reservations = []

        response.reservations.map(m => {

          let date

          for (let i = 0; i < m.date_num ; i++) {

            date = moment(m.date).add(i, "days").format("YYYY-MM-DD");

            reservations.push({
              customer_id: m.customer_id,
              date: date,
              first_name: m.first_name,
              first_name_kana: m.first_name_kana,
              information_status: m.information_status,
              input_rooms: m.input_rooms,
              is_jalan: i.is_jalan,
              last_name: m.last_name,
              last_name_kana: m.last_name_kana,
              reservation_id: m.reservation_id,
              status: m.status
            });
          }

          return true
        })

        let event = this.state.event;

        event.map((n,i) => {
          let p = 1
          let doubleBooking = false
          reservations.map(m => {
            m.input_rooms.map(room => {
              if(room === n.room){
                if(n.date === m.date) {
                  if(p > 1){
                    doubleBooking = true
                    enqueueSnackbar(moment(m.date).format("M月D日") + " にダブルブッキングがあります。",{variant : 'error', autoHideDuration: 10000,});
                  }

                  p++

                  event.splice(i,1,{
                    title: n.title + " (" + m.last_name + " 様)",
                    allDay: n.allDay,
                    start: n.start,
                    end: n.end,
                    date: n.date,
                    room: n.room,
                    isReserved: true,
                    reservationId: m.reservation_id,
                    doubleBooking: doubleBooking
                  });

                  return true
                }
                return false
              }
              return false
            })
            return false
          })

          response.holidays.map((holiday) => {
            if(n.isHolidayEvent){
              if(n.date === holiday){
                event.splice(i,1,{
                  title: n.title,
                  allDay: n.allDay,
                  start: n.start,
                  end: n.end,
                  date: n.date,
                  room: n.room,
                  isReserved: n.isReserved,
                  reservationId: n.reservation_id,
                  isHolidayEvent: n.isHolidayEvent,
                  isHoliday: true
                });
              }
            }
            return false
          })
          return false
        })

        this.setState({
          event: event,
          calendarHeight: $(".rbc-date-cell").length > 35 ? 1600 : 1370
        })

      }).catch(error => {
        console.log(error);
        if(error.message){
          enqueueSnackbar(error.message, {variant : 'error'})
        }else{
          enqueueSnackbar('エラーが発生しました。', {variant : 'error'})
        }
      })
    })
  }

  eventStyleGetter = (event, start, end, isSelected) => {
    console.log(event);
    var backgroundColor = '#' + event.hexColor;
    var style = {
        backgroundColor: backgroundColor,
        borderRadius: '0px',
        opacity: 0.8,
        color: 'black',
        border: '0px',
        display: 'block'
    };
    return {
        style: style
    };
  }

  setJapaneseHolidays = () => {

    let firstDay = moment(this.state.firstDay)
    let year = firstDay.year();
    let monthDays = firstDay.daysInMonth();

    let japaneseHolidays = JapaneseHolidays.getHolidaysOf(year);

    let japaneseHolidaysThisMonth = japaneseHolidays.filter((holiday) => {
      if(moment().year(year).month(holiday.month - 1).date(holiday.date).format("YYYY-MM") === firstDay.format("YYYY-MM")){
        return true
      }
      return false
    })

    if(japaneseHolidaysThisMonth.length > 0){
      for (let i = 1 ; i < monthDays + 1; i++) {

        japaneseHolidaysThisMonth.map((holiday) => {
          if(firstDay.date(i).format("YYYY-MM-DD") === moment().year(year).month(holiday.month -1).date(holiday.date).format("YYYY-MM-DD")){
            setTimeout(() => {
              $(".rbc-day-bg:not('.rbc-off-range-bg')").eq(i - 1).addClass("holiday-bg")
              $(".rbc-date-cell:not('.rbc-off-range')").eq(i - 1).addClass("holiday")
              $(".rbc-date-cell:not('.rbc-off-range')").eq(i - 1).html('<a href="#">' + i +  '<br/><div class="holiday-name">' + holiday.name + '</div></a>')

            }, 0)
          }

          return false
        })
      }
    }
  }

  onRangeChange = (event) => {
    $(".rbc-date-cell").html((index, element) => {
      let str = element
      let str1 = str.replace('<a href="#">', '<div>')
      let str2 = str1.replace('</a>', '</div>')
      return str2
    })

    let day = new Date(event.start);
    day.setDate(day.getDate() + 7)
    let firstDay = moment(new Date(day.getFullYear(), day.getMonth(), 1)).format("YYYY-MM-DD");

    //6段になる月のときに、eventが+more表示にならないように大きい方の高さに初期化する
    this.setState({
      calendarHeight: 1600,
      isRangeButtonActive: false,
      firstDay: firstDay
    }, () => {

      setTimeout(() => {
        this.setState({
          isRangeButtonActive: true
        })
      }, 500)

      let day = new Date(event.start);
      day.setDate(day.getDate() + 7)
      let firstDay = new Date(day.getFullYear(), day.getMonth(), 1);
      let year = firstDay.getFullYear();
      let month = firstDay.getMonth();
      let monthDays = getLastDay(year, month);

      let calendarEvent = []

      for (let i = 1 ; i < monthDays + 1; i++) {

        roomNames.map((room) => {
          calendarEvent.push(
            {
              title: room,
              allDay: true,
              start: new Date(year, month, i),
              end: new Date(year, month, i),
              date: moment(new Date(year, month, i)).format('YYYY-MM-DD'),
              room: room,
              isReserved: false
            }
          )
          return true
        })

        calendarEvent.push(
          {
            title: "満室表示",
            allDay: true,
            start: new Date(year, month, i),
            end: new Date(year, month, i),
            date: moment(new Date(year, month, i)).format('YYYY-MM-DD'),
            room: "",
            isReserved: false,
            isHolidayEvent: true,
            isHoliday: false
          }
        )

        this.setState({
          event: calendarEvent
        })

      }

      let apiName = 'MyAPIGatewayAPI';
      let path = '/search-reservations-for-calendar';

      let body = {
        date: moment(firstDay).format("YYYY-MM-DD"),
      };

      let myInit = {
        body: body, // replace this with attributes you need
      }

      const { enqueueSnackbar } = this.props;

      API.post(apiName, path, myInit).then(response => {
        console.log(response);

        let reservations = []

        response.reservations.map(m => {

          let date

          for (let i = 0; i < m.date_num ; i++) {

            date = moment(m.date).add(i, "days").format("YYYY-MM-DD");

            reservations.push({
              customer_id: m.customer_id,
              date: date,
              first_name: m.first_name,
              first_name_kana: m.first_name_kana,
              information_status: m.information_status,
              input_rooms: m.input_rooms,
              is_jalan: i.is_jalan,
              last_name: m.last_name,
              last_name_kana: m.last_name_kana,
              reservation_id: m.reservation_id,
              status: m.status
            });
          }

          return true

        })

        let event = this.state.event;

        event.map((n,i) => {
          let p = 1
          let doubleBooking = false
          reservations.map(m => {
            m.input_rooms.map(room => {
              if(room === n.room){
                if(n.date === m.date) {
                  if(p > 1){
                    doubleBooking = true
                    enqueueSnackbar(moment(m.date).format("M月D日") + " にダブルブッキングがあります。",{variant : 'error', autoHideDuration: 10000,});
                  }

                  p++

                  event.splice(i,1,{
                    title: n.title + " (" + m.last_name + " 様)",
                    allDay: n.allDay,
                    start: n.start,
                    end: n.end,
                    date: n.date,
                    room: n.room,
                    isReserved: true,
                    reservationId: m.reservation_id,
                    doubleBooking: doubleBooking
                  });

                  return true
                }
                return false
              }
              return false
            })
            return false
          })

          response.holidays.map((holiday) => {
            if(n.isHolidayEvent){
              if(n.date === holiday){
                event.splice(i,1,{
                  title: n.title,
                  allDay: n.allDay,
                  start: n.start,
                  end: n.end,
                  date: n.date,
                  room: n.room,
                  isReserved: n.isReserved,
                  reservationId: n.reservation_id,
                  isHolidayEvent: n.isHolidayEvent,
                  isHoliday: true
                });
              }
            }
            return false
          })
          return false
        })

        this.setState({
          event: event,
          calendarHeight: $(".rbc-date-cell").length > 35 ? 1600 : 1370
        })

      }).catch(error => {
        console.log(error);
        if(error.message){
          enqueueSnackbar(error.message, {variant : 'error'})
        }else{
          enqueueSnackbar('エラーが発生しました。', {variant : 'error'})
        }
      })
    })
  }

  onSelectEvent = (e) => {
    if(e.isHolidayEvent){
      let apiName = 'MyAPIGatewayAPI';
      let path = '/holidays';

      let body = {
        date: e.date,
      };

      let myInit = {
        body: body, // replace this with attributes you need
      }
      const { enqueueSnackbar } = this.props;

      API.post(apiName, path, myInit).then(response => {
        console.log(response);

        enqueueSnackbar(response.message, {variant : 'success'});

        let event = this.state.event;

        event.map((n,i) => {

          if(n.isHolidayEvent && n.date === e.date ){
            event.splice(i,1,{
              title: n.title,
              allDay: n.allDay,
              start: n.start,
              end: n.end,
              date: n.date,
              room: n.room,
              isReserved: n.isReserved,
              reservationId: n.reservation_id,
              isHolidayEvent: n.isHolidayEvent,
              isHoliday: n.isHoliday ? false : true
            });
          }

          return false
        })

        this.setState({
          event: event
        })
      }).catch(error => {
        if(error.message){
          enqueueSnackbar(error.message, {variant : 'error'})
        }else{
          enqueueSnackbar('エラーが発生しました。', {variant : 'error'})
        }
      })

    }else{
      if(!e.isReserved){
        this.props.history.push('/main/reservation?date=' + e.date + '&room=' + e.room);
      }else{
        this.props.history.push('/main/reservation-manage?reservationId=' + e.reservationId);
      }
    }
  }

  render() {
    const {classes} = this.props
    const {
      event,
      calendarHeight
    } = this.state;

    return (
      <Fragment>
        <Grid container spacing={24} className={classes.container}>
          <Grid item xs={12}>
            <Typography variant="h4" gutterBottom>
              空室情報
            </Typography>
          </Grid>
          <Grid item xs={12} style={{height: calendarHeight, maxWidth:900, minWidth:825}}>
            <BigCalendar
              localizer={localizer}
              events={event}
              startAccessor="start"
              endAccessor="end"
              views={['month']}
              formats={formats}
              components={{
                toolbar: CustomToolbar
              }}
              onSelectEvent={(event) => this.onSelectEvent(event)}
              onRangeChange={(event) => this.onRangeChange(event)}
              toolbar={this.state.isRangeButtonActive}
              eventPropGetter={
                (event) => {
                  let newStyle = {
                    backgroundColor: "lightgrey"
                  };

                  if(event.isReserved){
                    newStyle.backgroundColor = "#04d0d0"
                  }

                  if(event.doubleBooking){
                    newStyle.backgroundColor = "#ff0000d1"
                  }

                  if(event.isHolidayEvent){
                    newStyle.width= "60%";
                    newStyle.textAlign = "center";
                    newStyle.display = "block";
                    newStyle.margin = "auto";
                    newStyle.marginTop = "10px";
                    newStyle.paddingRight = "10px";
                    newStyle.borderRadius = "25px";

                    if(event.isHoliday){
                      newStyle.width= "70%";
                      newStyle.backgroundColor = "#ff73ee"
                      newStyle.fontWeight = "bold"
                      newStyle.border = "solid 3px red"
                      newStyle.fontSize = "0.7em"
                      newStyle.marginTop = "7px";
                    }
                  }

                  return {
                    className: "",
                    style: newStyle
                  };
                }
              }
              dayPropGetter={
                (date) => {
                  this.setJapaneseHolidays()
                }
              }
            />
          </Grid>
        </Grid>
      </Fragment>
    );
  }
}

Calendar.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withSnackbar(withRouter(withStyles(styles, { withTheme: true })(Calendar)));
